var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_854_4716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 0C8.05838 0 0 8.05838 0 18C0 27.9405 8.05838 36 18 36C27.9416 36 36 27.9405 36 18C36 8.05838 27.9416 0 18 0Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3307 25.8098V18.9056C27.3307 15.2066 25.3563 13.4854 22.7227 13.4854C20.5976 13.4854 19.6458 14.6543 19.116 15.4744V13.7678H15.1132C15.1661 14.8984 15.1132 25.8098 15.1132 25.8098H19.116V19.0845C19.116 18.7256 19.1418 18.3656 19.2476 18.1091C19.5367 17.3903 20.1948 16.6455 21.3007 16.6455C22.7497 16.6455 23.3291 17.7491 23.3291 19.368V25.8109L27.3307 25.8098ZM10.8956 12.1241C12.2906 12.1241 13.1602 11.1983 13.1602 10.0429C13.1343 8.86164 12.2906 7.96277 10.9215 7.96277C9.55233 7.96277 8.65796 8.86164 8.65796 10.0429C8.65796 11.1994 9.52646 12.1241 10.8708 12.1241H10.8956ZM12.897 25.8098V13.7678H8.89533V25.8098H12.897Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_854_4716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinB);
export default __webpack_public_path__ + "static/media/linkedinB.277bf33f0d004970b2ad8caf6fa0c8f3.svg";
export { ForwardRef as ReactComponent };